import { trpc } from '@/shared/api/trpc';

export const useSwitchOrganization = () => {
  const utils = trpc.useUtils();
  return trpc.accounts.switchOrganization.useMutation({
    onSettled: () => {
      utils.auth.me.invalidate();
      utils.organizations.list.invalidate();
      utils.organizations.findAll.invalidate();
      utils.accounts.listForFilters.invalidate();
    },
  });
};
